import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentLoanUpdateAction from './equipmentLoanUpdate.action.json' with { type: 'json' }
import equipmentLoanObject from '../equipmentLoanObject'

const equipmentLoanUpdateDefinition = defineAction({
  ...equipmentLoanUpdateAction,

  input: equipmentLoanObject
    .pick({
      id: true,
      loanDate: true,
      estimatedDevolutionDate: true,
      returned: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default equipmentLoanUpdateDefinition
